import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  AndroidIcon,
  IphoneIcon,
  GameIcon,
  FlutterIcon,
  HealthcareIcon,
  ReactIcon,
} from "../../../../app-constants";
import { Link } from "gatsby";

const StackItem = [
  {
    icon: AndroidIcon,
    title: "Android App Development",
    description:
      "Revolutionize your business with cutting-edge Android app development solutions. By offering your customers a tailored experience through a sophisticated user interface, you have the potential to stand out in the market. We've already served various industries with our robust applications. Whether you require a native or hybrid application, we as a top-class Android app development company are here to assist you.",
  },
  {
    icon: IphoneIcon,
    title: "Iphone App Development",
    description:
      "If you aim to reach Apple users, we have the expertise to create a cutting-edge iOS software application. Given the unique demands and intricate processes associated with iPhone app development, we possess the ideal infrastructure to construct a robust mobile app. Just share your objectives with us, and we will transform your concept into a tangible reality using our iPhone app development services.",
  },
  {
    icon: GameIcon,
    title: "Game App Development",
    description:
      "We have established ourselves as a leading game app development company, consistently delivering excellence to our clients. You can rely on us to create resilient gaming applications for both Android and iOS platforms. Furthermore, our developers possess reliable expertise in crafting high-quality 2D and 3D mobile games. Additionally, we've successfully utilized HTML5 frameworks such as ImpactJS, Phaser, Turbulenz, and more.",
  },
  {
    icon: FlutterIcon,
    title: "Flutter App Development",
    description:
      "Elevate your business with Flutter, the most cutting-edge and dependable technology for cross-platform app development. We excel in this domain, offering diverse solutions to our clients. What sets Flutter apart is its unique capability to create Android and iOS apps using a shared codebase, enabling you to reach a broader audience. Our Flutter app development services deliver a high-definition user interface that surpasses expectations.",
  },
  {
    icon: HealthcareIcon,
    title: "Healthcare App Development",
    description:
      "We help our partners in the healthcare industry build feature-rich mobile applications like e-pharmacies, virtual doctors, and fitness with intuitive design and efficient security to foster a sustainable health-conscious society. Using the latest technologies, we are providing different software to manage billing and laboratory systems with real-time insights. As a healthcare app development company, we improvise the process while saving you both time and cost.",
  },
  {
    icon: ReactIcon,
    title: "React Native App Development",
    description:
      "We utilize the potential of this impeccable framework to craft robust mobile applications that seamlessly function on both Android and iOS platforms, ensuring comprehensive functionality and impeccable performance. Our skilled team actively creates apps that not only cater to your specific requirements but also provide a consistently exceptional user experience across various devices.",
  },
];

function Improvise(props) {
  return (
    <div className="improvise_section p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={10}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              Experience Full-fledged Mobile App Development Services in Toronto
            </h2>
            <p className="impro_para">
              Building diverse mobile applications requires expertise in various
              app development services. Having a versatile pool of top app
              developers in Toronto, we enable the business to create
              competitive mobile apps for different operating systems based on
              the latest techniques. Have a look at our authentic mobile app
              development services in Toronto to determine which suits your
              business requirements better.
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={10} className="m-auto">
            <div className="stack_box">
              {StackItem.map((item, index) => (
                <div className="stack_item" key={index}>
                  <div className="stack_title">
                    {item.icon}
                    <h5>{item.title}</h5>
                  </div>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Improvise;
